module.exports = __webpack_public_path__ + "img/grandmaster_notcompleted.10db40c4.svg";